export default "__VITE_ASSET__39089999__"